import ReactDOM from "react-dom";
import { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { feesPricingButtonStyle } from "../styles/styles";

function FeesPricingButton() {
  const [container, setContainer] = useState(null);

  const { t } = useTranslation("pricelist-header-content");

  useEffect(() => {
    const target = document.getElementById("header-sub-title");
    setContainer(target);
  }, []);

  if (!container) return null;

  return ReactDOM.createPortal(
    <Typography
      as="span"
      onClick={() =>
        window.open("https://communit-giveback-network.lovable.app/", "_blank")
      }
      sx={feesPricingButtonStyle}
    >
      {t("fees_pricing")}
      <img src="/icons/external-link-icon.svg" alt="external-link-icon" />
    </Typography>,
    container
  );
}

export default FeesPricingButton;
